import { useEffect, useState } from 'react';

//* Styles
import InfoBuildingStyle from './style';

//* Helpers
import numberSpecialSymbol from '@/modules/apartments-individual/components/Calculator/helpers-calculator';

//* Libs
import { getBuildingInfo } from '@/libs/get-data';

//* HOO'C
import { withLanguageContext } from '@/context';

//* Component
import Text from '@/components/common/Text';

const InfoBuilding = ({ translate, name, dataReady, selectedLang, floorData }) => {
	//! state
	const [dataBuilding, setDataBuilding] = useState(false);

	//! get building
	useEffect(() => {
		getBuildingInfo({ lang: selectedLang }).then((data) => {
			if (!data?.data) return;
			const currentData = data.data.filter((item) => item.name.toUpperCase() === name);
			if (currentData.length) setDataBuilding(currentData[0]);
		});
	}, []);

	return (
		<InfoBuildingStyle>
			{dataBuilding && (
				<div className='wrapper-info col-3 col-ts-5 col-m-12 opacity-0'>
					<div className='apartment-info'>
						<div className='item-info'>
							<Text
								className={'p1'}
								text={'building'}
							/>
							<Text className={'h5 font-montserrat-medium info-item'}>
								{translate('building')}&nbsp;#{name}
							</Text>
						</div>
						{dataBuilding ? (
							<div className='item-info'>
								<Text
									className={'p1'}
									text={'area'}
								/>
								<Text className={'h5 font-montserrat-medium info-item'}>
									{dataBuilding.min_area} - {floorData.length ? Math.max(...floorData.map((item) => item.max_area)) : ''}
									&nbsp;{translate('meter')}
									<sup>2</sup>
								</Text>
							</div>
						) : null}
						{dataBuilding ? (
							<div className='item-info'>
								<Text
									className={'p1'}
									text={'priceFrom'}
								/>
								<Text className={'h5 font-montserrat-medium info-item'}>
									{numberSpecialSymbol({ symbol: '.', number: dataBuilding.min_meter_price })}&nbsp;{translate('currency')}
								</Text>
							</div>
						) : null}

						<div className='item-info'>
							<Text
								className={'p1'}
								text={'willReady'}
							/>
							<Text className={'h5 font-montserrat-medium info-item'}>{dataReady}</Text>
						</div>
					</div>
				</div>
			)}
		</InfoBuildingStyle>
	);
};

export default withLanguageContext(InfoBuilding, ['translate', 'selectedLang']);
